import React from 'react';

import classes from '../installPics.css';

import CorrugatedImg3 from '../../../../../../../assets/CorrugatedImg3.jpg';

const CorrugatedPic
 = () => (
     <div className={classes.installImages}>
         <img alt="22kW residential installation in New Jersey" src={CorrugatedImg3} className={classes.installImg} />
     </div>
 );


export default CorrugatedPic;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/CorrugatedMetal/CorrugatedImg3.js